import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FounderSection from './components/FounderSection';
import ServicesPreview from './components/ServicesPreview';
import AIToolsPreview from './components/AIToolsPreview';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import { Link } from 'react-router-dom';
import { GraduationCap, BookOpen, FileText, CreditCard, ArrowRight } from 'lucide-react';

export default function Home() {
  return (
    <div className="font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <FounderSection />
        
        {/* Learning Hub Banner */}
        <section className="py-16 bg-gradient-to-br from-blue-900 via-blue-800 to-red-700 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-transparent"></div>
          <div className="absolute -top-20 -left-20 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-red-500/10 rounded-full blur-3xl"></div>
          
          <div className="container mx-auto px-6 relative z-10">
            <div className="max-w-4xl mx-auto text-center text-white">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium mb-6">
                <GraduationCap className="w-4 h-4" />
                <span>Professional Learning Platform for You</span>
              </div>
              <h2 className="font-display text-3xl md:text-5xl font-bold mb-6">
                Learning Hub
              </h2>
              <p className="text-lg md:text-xl text-blue-100 leading-relaxed max-w-2xl mx-auto mb-8">
                Master essential computer skills and build your career. Choose from Microsoft Word, Excel, PowerPoint, Internet & Email, CV Writing, Freelancing, AI Tools and more.
              </p>
              
              <div className="grid md:grid-cols-3 gap-4 mb-8 max-w-3xl mx-auto">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                  <BookOpen className="w-8 h-8 mx-auto mb-2 text-white" />
                  <p className="font-bold text-white">8 Courses</p>
                  <p className="text-sm text-blue-100">$2 per course</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                  <FileText className="w-8 h-8 mx-auto mb-2 text-white" />
                  <p className="font-bold text-white">CV Builder</p>
                  <p className="text-sm text-blue-100">Free preview</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                  <CreditCard className="w-8 h-8 mx-auto mb-2 text-white" />
                  <p className="font-bold text-white">Secure Payment</p>
                  <p className="text-sm text-blue-100">Flutterwave</p>
                </div>
              </div>

              <Link
                to="/learning-hub"
                className="inline-flex items-center gap-2 px-8 py-4 bg-white text-blue-900 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all duration-300 hover:scale-105 shadow-xl"
              >
                Start Learning Now
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </section>

        <ServicesPreview />
        <AIToolsPreview />
        <TestimonialsSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
